import { render, staticRenderFns } from "./UserCash.vue?vue&type=template&id=f23d8c1e&scoped=true&"
import script from "./UserCash.vue?vue&type=script&lang=js&"
export * from "./UserCash.vue?vue&type=script&lang=js&"
import style0 from "./UserCash.vue?vue&type=style&index=0&id=f23d8c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23d8c1e",
  null
  
)

export default component.exports